import styled from 'styled-components';
import {BaseColumnWrap} from '../../../CommonStyleUtils/dwebCommon.styles';
import Image from '@stencil/image';

export const HomeCaroMainWrap = styled.div(
  props => `
    width: 50%;
    padding-left: ${props.theme.spacing.base};
    z-index: ${props.theme.misc.zIndex.small};
    display: flex;
    flex-direction: column;
  `,
);

export const HomeCaroMainImageWrap = styled.div(
  props => `
    margin-bottom: ${props.theme.spacing.large};
    height: 19rem;
    width: 100%;
    background-color:${props.theme.colors.goBrandBlue.medium};
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    display: flex;
  `,
);

export const HomeCaroBigImg = styled(Image)(
  props => `
  width: 100%;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  object-fit: cover;
  `,
);

export const HomeCaroSliderInnerWrap = styled.ul(
  props => `
    display: flex;
    justify-content:space-between;
    position: relative;
    li{
      width:48%;
      height: 19.5rem;
      display: flex;
      flex-direction: column;
      background-color: ${props.theme.colors.goWhite.base};
      border-radius: ${props.theme.misc.borderRadius.xxxlarge};

      &:last-child {
        margin-right:0;
      }
    }
  `,
);

export const SliderImg = styled(Image)(
  props => `
    height: 10.8rem;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge} ${props.theme.misc.borderRadius.xxxlarge} 0 0;
    object-fit: cover;
  `,
);

export const SliderInfoWrap = styled(BaseColumnWrap)(
  props => `
    padding: ${props.theme.spacing.base} ${props.theme.spacing.xlarge};
  `,
);

export const SliderHeadInfoText = styled.p(
  props => `
    font-size: ${props.theme.font.custom(14)};
    line-height: 1.4;
  `,
);

export const SliderInfoSubText = styled.span(
  props => `
    color: ${props.theme.colors.downriver.medium};
    padding-top: ${props.theme.spacing.base};
  `,
);

export const SliderArrowRight = styled.button(
  props => `
    width: 4rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.goWhite.base};
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: -1rem;
    transform: translateY(-50%);
    box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
    border:none;
    &:focus{
      outline: none;
    }
  `,
);

export const SliderArrowLeft = styled.button(
  props => `
    width: 4rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.goWhite.base};
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: -1rem;
    transform: translateY(-50%);
    box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
    border:none;
    &:focus{
      outline: none;
    }
  `,
);
